import { IconValueSlider } from "../../../../components/Sliders/Sliders";

const ColorPicker = (props) => {
  const { colorValue, setColorValue } = props;

  return (
    <input
      className="h-12 w-12 cursor-pointer"
      type="color"
      value={colorValue}
      onChange={(event) => setColorValue(event.target.value)}
    />
  );
};

const ColorPickerRow = ({ colorTitle, colorValue, setColorValue }) => {
  return (
    <div className="flex flex-row items-center justify-between w-full">
      <div className="flex flex-row items-center justify-start w-full">
        <p className="text-xl font-medium text-neutral-900">{colorTitle}</p>
      </div>
      <div className="flex flex-row items-center justify-end w-full Xlg:pr-10">
        <ColorPicker colorValue={colorValue} setColorValue={setColorValue} />
      </div>
    </div>
  );
};

const SliderRow = ({
  sliderTitle,
  SliderIcon,
  sliderValue,
  setSliderValue,
  sliderMin,
  sliderMax,
  sliderStep,
}) => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-between w-full">
      <div className="flex flex-1 flex-row items-center justify-start w-full">
        <p className="text-xl font-medium text-neutral-900">{sliderTitle}</p>
      </div>
      <div className="py-1 md:py-0" />
      <div className="flex flex-1 flex-row items-center justify-end w-full Xlg:pr-10">
        <IconValueSlider
          sliderValue={Number(sliderValue).toFixed(2)}
          sliderMin={sliderMin}
          sliderMax={sliderMax}
          sliderStep={sliderStep}
          onChangeFunction={(event) => {
            setSliderValue(event.target.value);
          }}
          Icon={SliderIcon}
        />
      </div>
    </div>
  );
};

export { ColorPicker, ColorPickerRow, SliderRow };
